import { IColumnDefinition } from 'features/Lists/core/contracts/IColumnDefinition'
import { IListsActions } from 'features/Lists/core/store/actions'
import { IListsSelectors } from 'features/Lists/core/store/selectors'
import { ListTypes } from './types'

export interface IUseListHookDefinition<T extends string = string> {
  listType: T
  columnDefinitions: Record<string, IColumnDefinition>
  actions: IListsActions<any>
  selectors: IListsSelectors<any>
}

export const hookDefinitions: Record<
  ListTypes,
  IUseListHookDefinition<ListTypes>
> = {
  recon: {
    listType: 'recon',
    columnDefinitions: {} as Record<string, IColumnDefinition>, // Will be populated by the ReconAI module
    actions: {} as IListsActions<any>, // Will be populated by the ReconAI module
    selectors: {} as IListsSelectors<any> // Will be populated by the ReconAI module
  },
  suppressed: {
    listType: 'suppressed',
    columnDefinitions: {} as Record<string, IColumnDefinition>, // Will be populated by the ReconAI module
    actions: {} as IListsActions<any>, // Will be populated by the ReconAI module
    selectors: {} as IListsSelectors<any> // Will be populated by the ReconAI module
  },
  sei: {
    listType: 'sei',
    columnDefinitions: {} as Record<string, IColumnDefinition>, // Will be populated by the ReconAI module
    actions: {} as IListsActions<any>, // Will be populated by the ReconAI module
    selectors: {} as IListsSelectors<any> // Will be populated by the ReconAI module
  }
}
